export const CAPTURE_FRONT_SIDE = 'CAPTURE_FRONT_SIDE';
export const CAPTURE_BACK_SIDE = 'CAPTURE_BACK_SIDE';
